import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommonService } from '../../../../shared/services/common.service';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import { DashboardService } from '../../../../services/dashboard.service';
import { CommunityLotModel } from '../../../../models/CommunitylotModel';
import { SubscriptionService } from '../../../../shared/services/subscription.service';
import { Subscription } from 'rxjs/Subscription';
import { Utilities } from '../../../../Utilities';
import { SignalRService } from '../../../../services/signalr.service';
import { DisplayNotificationListModel } from '../../../../models/SignalrModel';
import { DxSelectBoxComponent } from 'devextreme-angular';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [DashboardService]
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild("communityLotSelectBox") communityLotSelectBox: DxSelectBoxComponent;
  AuthUserObj: any = undefined;
  public buyerText: string;
  public messageNotificationCount: number;
  public communityLots: CommunityLotModel[] = [];
  private subscriptions: Subscription[] = [];

  public notificationsList: Array<DisplayNotificationListModel> = new Array<DisplayNotificationListModel>();
  public totalMessages: number = 0;
  constructor(public commonService: CommonService, public _router: Router,
    public signalRService: SignalRService,
    public dashboardService: DashboardService,
    public subscriptionService: SubscriptionService) {
    Utilities.renderGoogleTranslateScript();
    this.AuthUserObj = commonService.AuthUser.getValue();
  }
  

  public onLotValueChanged(data) {
    // debugger;
    // console.log('ContractID', this.communityLots);
    if (data.previousValue != 0 && data.value) {
      let str = this._router.url;
      let unBlockedUrls = ['/ServicesMaintenance/0/ServiceRequest',
        '/ServicesMaintenance/1/ServiceRequest', '/messages/1', '/messages/0'];
      if (unBlockedUrls.some(x => str.toLowerCase().includes(x.toLowerCase()))) {
        str = unBlockedUrls.find(x => str.toLowerCase().includes(x.toLowerCase()));
      } else {
        if ((str.match(new RegExp("/", "g")) || []).length > 1) {
          str = str.substring(1, str.length);
          str = "/" + str.substring(0, str.indexOf('/'));//.toLowerCase();
        }
      }
      // console.log('data.value',data,data.value);
      const selectedCommunity = this.communityLots.find(lot => lot.CommunityLotID == data.value);
      const currentContractId = selectedCommunity ? selectedCommunity.ContractID : '';
      const IsCoBuyer = selectedCommunity ? selectedCommunity.IsCobuyer : false;
      // console.log('currentContractId0, ', currentContractId, selectedCommunity, str);
      this.subscriptionService.setCommunityLotId(+data.value);

      this.subscriptionService.setContractID(+currentContractId);
      this.subscriptionService.setSurveyTemplateID(0);
      this.subscriptionService.setBothID(+data.value, +currentContractId);
      this.AuthUserObj.IsCobuyer=IsCoBuyer;
      this.commonService.setAuthUser(this.AuthUserObj);
      // console.log("Change call",IsCoBuyer);
      this._router.navigate([str]);
    }

    this.subscriptionService.IsDesignFeatureEnabled$.next(
      this.communityLots.some(x => x.CommunityLotID === data.value) ? this.communityLots.find(x => x.CommunityLotID === data.value)
        .IsDesignFeatureEnabled : false);
        this.subscriptionService.IsWarrantyenable$.next(
          this.communityLots.some(x => x.CommunityLotID === data.value) ? this.communityLots.find(x => x.CommunityLotID === data.value)
            .IsWarrantyenable : false);
            this.subscriptionService.WarrantyExiprydate$.next(
              this.communityLots.some(x => x.CommunityLotID === data.value) ? this.communityLots.find(x => x.CommunityLotID === data.value)
                .WarrantyExiprydate : null);
    if (this.AuthUserObj && this.AuthUserObj.BuyerID > 0) {
      this.buyerText = this.communityLots.find(x => x.CommunityLotID == data.value).IsClosed ? "Home Owner" : "Customer";
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
    this.totalMessages = 0;
  }

  ngOnInit() {
    this.subscriptions.push(this.commonService.AuthUser.subscribe(buyerObj => {
      if (buyerObj) {
        this.AuthUserObj = buyerObj;
        this.bindOfflineNotifications();
      }
    }));
    this.subscriptions.push(this.signalRService.clearNotification$.subscribe(x => {
      if (x) {
        this.clearList(x.CommunityLotId, x.NotificationType);
      }
    }));
    this.subscriptions.push(this.signalRService.notificationData$.subscribe(x => {
      if (x) {
        let notification = this.notificationsList.find(y => y.CommunityLotId === x.CommunityLotId);
        if (notification) {
          notification.NotificationModel.push(x);
        } else {
          let notification: DisplayNotificationListModel = new DisplayNotificationListModel();
          notification.CommunityLotId = x.CommunityLotId;
          notification.CommunityLotName = x.CommunityLotName;
          notification.NotificationModel.push(x);
          this.notificationsList.push(notification);
        }
        this.totalMessages = this.totalMessages + 1;
        if (x.CommunityLotId === this.subscriptionService.CommunityLotId$.getValue() &&
          ((this._router.url.includes('messages/1') && x.NotificationType === 0)
            || (this._router.url.includes('messages/0') && x.NotificationType === 1)
            || (this._router.url.includes('/ServicesMaintenance/0/ServiceRequest') && x.NotificationType === 2)
            || (this._router.url.includes('/survey') && x.NotificationType === 3)
            )) {
          this.signalRService.refreshGrids$.next(1);
        }
      }
    }));
    this.subscriptions.push(this.signalRService.removeNotificationData$.subscribe(x => {
      if (x) {
        let currentNotificationRecord =
          this.notificationsList.find(y => y.CommunityLotId === x.CommunityLotId);
        if (currentNotificationRecord && currentNotificationRecord) {
          let currentIndex = currentNotificationRecord.NotificationModel.findIndex(z => z.NotificationId === x.NotificationId);
          currentNotificationRecord.NotificationModel.splice(currentIndex, 1);
          this.totalMessages = this.totalMessages - 1;
        }
      }
    }));

    this.subscriptions.push(this.dashboardService.getCommunityLotByBuyerId().subscribe(async x => {
      this.communityLots = x ? x.communitylot : [];

      this.communityLots.forEach(element => {
        element.LotNo = element.CommunityName + ' - ' + element.LotNo
      });
      this.subscriptionService.communityLots = this.communityLots.map(x => {
        return {
          CommunityLotId: x.CommunityLotID,
          CommunityID: x.CommunityID,
          ContractId: x.ContractID
        }
      });

      if (this.communityLots.length > 0) {
        this.subscriptionService.setCommunityLotId(this.communityLots[0].CommunityLotID);
        this.subscriptionService.setContractID(this.communityLots[0].ContractID);
        this.subscriptionService.setIsWarrantyenable(this.communityLots[0].IsWarrantyenable);
        this.subscriptionService.setWarrantyDate(this.communityLots[0].WarrantyExiprydate);
        this.subscriptionService.setBothID(+(this.communityLots[0].CommunityLotID), +(this.communityLots[0].ContractID));
        
        this.AuthUserObj.IsCobuyer=this.communityLots[0].IsCobuyer;
        this.commonService.setAuthUser(this.AuthUserObj);
      }
      
      if (this.communityLots.length === 1) {
        this.buyerText = this.communityLots[0].IsClosed ? "Home Owner" : "Customer";
        this.subscriptionService.IsDesignFeatureEnabled$.next(this.communityLots[0].IsDesignFeatureEnabled);
      }
    }));

    this.commonService.getDisclosureMessageFromConfig().subscribe(x => {
      this.subscriptionService.designDisclosureMessage = x.Value;
    });

  }

  private bindOfflineNotifications() {
    if (this.AuthUserObj && this.AuthUserObj.BuyerID > 0) {
      this.dashboardService.getOfflineNotifications().subscribe(x => {
        if (x && x.length > 0) {
          this.notificationsList = x;
          this.totalMessages = 0;
          this.notificationsList.forEach(z => {
            this.totalMessages += z.NotificationModel.length
          });
        }
        console.log("called From Offline");
      });
    }
  }

  public onNotificationClick(communityLotId: number, notificationType: number) {
    this.clearNotifications(communityLotId, notificationType);
    switch (notificationType) {
      case 0:
        this._router.navigate(['/messages/1']);
        break;
      case 1:
        this._router.navigate(['/messages/0']);
        break;
      case 2:
        this._router.navigate(['/ServicesMaintenance/0/ServiceRequest']);
        break;
      case 3:
          this._router.navigate(['/survey']);
          break;
    }
  }

  private clearNotifications(communityLotId: number, notificationType: number) {
    if (this.subscriptionService.CommunityLotId$.getValue() === communityLotId) {
      this.signalRService.updateData$.next(1);
    } else {
      this.communityLotSelectBox.value = communityLotId;
    }
    this.clearList(communityLotId, notificationType);
  }

  private clearList(communityLotId: number, notificationType: number) {
    if (this.notificationsList.some(x => x.CommunityLotId === communityLotId &&
      x.NotificationModel.some(x => x.NotificationType === notificationType))) {
      this.dashboardService.deleteNotifications(communityLotId, notificationType).subscribe(x => {
        this.notificationsList = !x ? new Array<DisplayNotificationListModel>() : x;
        this.totalMessages = 0;
        this.notificationsList.forEach(l => {
          this.totalMessages += l.NotificationModel.length;
        });
        if (this.notificationsList.length === 0) {
          this.totalMessages = 0;
        }
      });
    }
  }

  logoutClick(event: any) {
    localStorage.removeItem(environment.token);
    localStorage.removeItem('BuyerInfo');
    
    if (this.AuthUserObj && this.AuthUserObj.BuyerID > 0) {
      if (this.signalRService._connectionNotificationHub) {
        this.signalRService._connectionNotificationHub.stop();
        this.signalRService._connectionNotificationHub = undefined;
      }
    }
    localStorage.removeItem("CommunityLotId");

    this._router.navigate(['/login']);
  }

  onProfileClick(event: any) {
    this._router.navigate(['/profile']);
  }
  

}



// WEBPACK FOOTER //
// ./src/app/containers/layout/components/header/header.component.ts